/* Timo's story copy, Norwegian Bokmal. A retelling, not a translation.
 *
 * THIS IS THE FILE TO EDIT. Every line here is spoken out loud by Timo,
 * so write it the way it should sound, not the way it should look.
 *
 * How it plays: the story is five chapters. Each chapter is ONE text to
 * speech call, composed as
 *     [celebration or encouragement for the last word] + [chapter] + [invitation]
 * so the whole story costs five calls. That matters: the TTS layer allows
 * five calls per sixty seconds before it locks out, and caps a single call
 * at 2500 characters and silently truncates past it. Keep every chapter
 * between 500 and 700 characters and the composed line stays safe.
 *
 * Two refrains repeat word for word on purpose. A child joins in by the
 * third time they hear them, and joining in is the whole point:
 *     Timo hører etter. Timo venter. Timo hjelper.
 *     Si det sammen med meg, sa Timo.
 * Do not vary them for style. Sameness is the feature.
 *
 * The four target words are what the CHILD is asked to say. They are
 * picked to be the easiest words in their chapter, not the prettiest:
 * hus, nøtt, vann, glad. All are one syllable and lead with early
 * developing sounds. Chapter 1 was rewritten so that Timo lives in a
 * little house, because hus is far easier for a small mouth than hjem or
 * hjemmet. Do not swap one for a nicer word.
 */

const storyNo = {
  'story.title': 'Timos grønne skog',
  // Timo hands the telling over to Hoppy, then the recorded story plays.
  'story.handoff': "Hei! Jeg spør vennen min Hoppy om å fortelle den.",

  // ==== Chapter 1: who Timo is (target: hus, replaces English home) ====
  'story.ch1':
    'Timo bor i en stor grønn skog. Timo er liten. Timo har en myk stripete hale. ' +
    'Timo har store runde ører. Store ører er fine å høre med. Mange dyr bor i skogen. ' +
    'Det er en stor rolig bjørn. Det er en liten fugl. Det er to sultne ekorn. ' +
    'Alle snakker på en gang. Det blir så bråkete. Men Timo snakker ikke først. ' +
    'Timo hører etter. Timo venter. Timo hjelper. Timo har et lite hus i et gammelt tre. ' +
    'Det er et varmt og mykt hus. Huset har en liten rund dør. Fra huset kan Timo se hele skogen. ' +
    'Timo liker huset sitt godt.',

  // ==== Chapter 2: the two squirrels (target: nott) ====
  'story.ch2':
    'En dag fant de to ekornene en nøtt. Det var en stor brun nøtt. Begge ville ha den nøtta. ' +
    'De dro nøtta hit. De dro nøtta dit. De sa ikke ett eneste ord. De bare dro og dro. ' +
    'Da kom Timo og satte seg ned. Timo hører etter. Timo venter. Timo hjelper. ' +
    'Så sa Timo, fortell meg hva du vil ha. Si det sammen med meg, sa Timo. ' +
    'Det første ekornet sa, jeg vil ha nøtta. Det andre ekornet sa, jeg vil ha nøtta også. ' +
    'Nå vet vi det, sa Timo. Dere kan dele nøtta. Så delte de nøtta i to. ' +
    'Hvert ekorn fikk en halv nøtt. Begge ble like fornøyde.',

  // ==== Chapter 3: the little bird, the heart of it (target: vann) ====
  'story.ch3':
    'Så kom den lille fuglen. Han satt på en lav grein. Han var varm og han var tørst. ' +
    'Fuglen ville si noe. Men ordet ville ikke komme ut. Han åpnet nebbet. Ingenting kom. ' +
    'Han så ned på føttene sine. Ingen maste på ham. ' +
    'Timo hører etter. Timo venter. Timo hjelper. Timo satt helt stille ved siden av ham. ' +
    'Så sa Timo ordet først, sakte og mykt. Vann. Si det sammen med meg, sa Timo. ' +
    'Fuglen prøvde. Va. Han prøvde en gang til. Vann. Han sa det! Han sa vann! ' +
    'Timo hoppet opp og ned. Hele den grønne skogen jublet for den lille fuglen.',

  // ==== Chapter 4: the forest changes, Timo hears the children (target: glad) ====
  'story.ch4':
    'Etter den dagen var skogen annerledes. Bjørnen ville ha et bær. Da sa han bær. ' +
    'Ekornene ville leke. Da sa de leke. Fuglen var tørst. Da sa han vann. ' +
    'Ingen dro. Ingen dyttet. Nå hadde alle et ord. Timo var glad. Bjørnen var glad. ' +
    'Fuglen var glad. Hele den grønne skogen var glad. ' +
    'Om kvelden satt Timo på den varme steinen sin og så på månen. Da hørte han noe helt nytt. ' +
    'Langt borte, bak trærne, var det barn. De hadde store ting å fortelle. ' +
    'Morsomme ting og fine ting. Men ordene satt fast inni dem. Timo satt helt stille.',

  // ==== Chapter 5: Timo comes to the child ====
  'story.ch5':
    'Om morgenen pakket Timo en liten veske. Han sa ha det til den store rolige bjørnen. ' +
    'Han sa ha det til de to ekornene. Han sa ha det til den lille fuglen. ' +
    'Fuglen sang en sang til ham. I sangen var det masse ord. ' +
    'Så gikk Timo ut av den store grønne skogen. Han gikk en lang, lang vei. ' +
    'Han holdt de store ørene sine åpne hele tiden. Timo hører etter. Timo venter. Timo hjelper. ' +
    'Og en dag, langt fra skogen, hørte han deg. Så nå er jeg her. ' +
    'Jeg er ikke i skogen lenger. Jeg er her hos deg. ' +
    'Og du har store ting å fortelle. Jeg vil så gjerne høre dem.',

  // ==== The four pauses: invitation, target word, celebration, encouragement ====
  'story.invite1': 'Det lille huset er hjemmet til Timo, si hus sammen med meg.',
  'story.invite2': 'En stor brun nøtt til to venner, si nøtt sammen med meg.',
  'story.invite3': 'Den lille fuglen fant ordet sitt, si vann sammen med meg.',
  'story.invite4': 'Hele den grønne skogen var glad, si glad sammen med meg.',

  'story.word1': 'hus',
  'story.word2': 'nøtt',
  'story.word3': 'vann',
  'story.word4': 'glad',

  'story.celebrate1': 'Hus! Du sa det, og de store ørene mine vippet av glede.',
  'story.celebrate2': 'Nøtt! Det var fint. Begge ekornene vinker til deg.',
  'story.celebrate3': 'Vann! Du sa det akkurat som fuglen. Jeg er så stolt av deg.',
  'story.celebrate4': 'Glad! Det er yndlingsordet mitt, og du sa det.',

  'story.encourage1': 'Hus, hus, et lite koselig hus. Bli med, så får du møte vennene mine.',
  'story.encourage2': 'Nøtt, nøtt, en stor brun nøtt. Nå får du møte den lille fuglen.',
  'story.encourage3': 'Vann, vann, en kald liten slurk vann. Kom og se hva som skjedde etterpå.',
  'story.encourage4': 'Glad, glad, en hel skog full av glade dyr. Bli med meg til slutten.',

  'story.ending':
    'Kom tilbake i morgen, så forteller jeg om bjørnen og det aller siste bæret. God natt, vennen min.',
};

export default storyNo;
